
const Icon = (props: any) => {

  let icon = props.icon ?? '';
  let color = props.color ?? '';
  let className = props.className ?? '';
  return (
    <span style={{ color: color }} className={`material-symbols-outlined ${className}`} >
      {icon}
    </span>
  )
}

export default Icon;
